import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'brand',
    serviceName: 'graphql',
    query: gql`
      query brand(
        $ids: [String]
        $producer_ids: [String]
        $title: String
        $category_id: String
        $shop_id: String
        $is_active: Int
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        brand(
          ids: $ids
          producer_ids: $producer_ids
          title: $title
          category_id: $category_id
          shop_id: $shop_id
          is_active: $is_active
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
            media {
              full_url
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteBrand',
    serviceName: 'admin',
    query: gql`
      mutation deleteBrand($ids: [String]!) {
        deleteBrand(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'brand',
    serviceName: 'grapghql',
    query: gql`
      query brand($ids: [String]) {
        brand(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'brand',
    serviceName: 'grapghql',
    query: gql`
      query brand($ids: [String]) {
        brand(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
